import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3987891a&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=3987891a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987891a",
  null
  
)

export default component.exports